/**
 * FAQ Archive search filter.
 *
 * Client-side filter for the faq-archive block. As the user types, items
 * whose text doesn't include the term are hidden, the block enters
 * `is-searching` mode (CSS hides section headers + flattens spacing), and
 * an empty-state line appears when nothing matches. Clearing the input
 * restores the original sectioned layout.
 *
 * Per-block scoping — multiple faq-archive blocks on a page each filter
 * independently. Each module instance only touches its own block's items.
 */

const SEARCH_DEBOUNCE_MS = 120;

const filter = (raw, block, items, empty) => {
    const term = raw.trim().toLowerCase();

    if (!term) {
        block.classList.remove('is-searching');
        items.forEach((item) => item.classList.remove('is-hidden'));
        if (empty) empty.hidden = true;
        return;
    }

    block.classList.add('is-searching');

    let visible = 0;
    items.forEach((item) => {
        // textContent walks the entire subtree (question + answer), so a
        // term anywhere in the FAQ matches even if the answer is currently
        // collapsed inside <details>. Browsers expose collapsed
        // <details> content via textContent regardless of open state.
        const hay = item.textContent.toLowerCase();
        const match = hay.includes(term);
        item.classList.toggle('is-hidden', !match);
        if (match) visible += 1;
    });

    if (empty) empty.hidden = visible > 0;
};

const setupBlock = (block) => {
    const input = block.querySelector('.faq-archive__search-input');
    if (!input) return;

    const items = block.querySelectorAll('.faq-archive__item');
    const empty = block.querySelector('.faq-archive__empty');
    let timer;

    input.addEventListener('input', (e) => {
        clearTimeout(timer);
        const value = e.target.value;
        timer = setTimeout(() => filter(value, block, items, empty), SEARCH_DEBOUNCE_MS);
    });
};

const initFAQSearch = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.faq-archive').forEach(setupBlock);
    });
};

export { initFAQSearch };
